var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSportsLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "none",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    fill: "#fff",
    stroke: "#E5E8EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear)",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear)",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BCDE4",
    d: "M79.7001 49.8501C79.7001 66.3358 66.3358 79.7001 49.8501 79.7001C33.3643 79.7001 20 66.3358 20 49.8501C20 33.3643 33.3643 20 49.8501 20C66.3358 20 79.7001 33.3643 79.7001 49.8501Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    d: "M48.2824 39.1996C49.3142 38.479 50.6861 38.479 51.7179 39.1996L55.784 42.0393L59.7411 45.0289C60.7453 45.7875 61.1692 47.0922 60.8027 48.2961L59.3585 53.0407L57.7381 57.7281C57.3269 58.9175 56.2171 59.7238 54.9588 59.7473L50.0002 59.84L45.0415 59.7473C43.7832 59.7238 42.6734 58.9175 42.2622 57.7281L40.6418 53.0407L39.1976 48.2961C38.8311 47.0922 39.255 45.7875 40.2592 45.0289L44.2163 42.0393L48.2824 39.1996Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M48.2824 31.8004C49.3142 32.521 50.6861 32.521 51.7179 31.8004L55.784 28.9607L59.7411 25.9711C60.7453 25.2125 61.1692 23.9078 60.8027 22.7039L60.585 21.9884C57.2537 20.7041 53.6342 20 49.8502 20C46.1942 20 42.6917 20.6573 39.4544 21.8601L39.1976 22.7039C38.8311 23.9078 39.255 25.2125 40.2592 25.9711L44.2163 28.9607L48.2824 31.8004Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M66.6514 43.2018C66.2584 44.3973 66.6533 45.7111 67.6403 46.4918L71.5302 49.5684L75.5324 52.4975C76.5479 53.2408 77.9194 53.2712 78.9669 52.5737L79.5894 52.1592C79.8605 48.5993 79.4929 44.9303 78.4037 41.3064C77.3513 37.8051 75.7136 34.6401 73.6298 31.886L72.7479 31.883C71.4894 31.8786 70.3619 32.6601 69.9245 33.8401L68.2005 38.4904L66.6514 43.2018Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M32.9423 43.2018C33.3354 44.3973 32.9405 45.7111 31.9534 46.4918L28.0635 49.5684L24.0614 52.4975C23.0458 53.2408 21.6743 53.2712 20.6268 52.5737L20.0043 52.1592C19.7333 48.5993 20.1009 44.9303 21.1901 41.3064C22.2425 37.8051 23.8801 34.6401 25.9639 31.886L26.8459 31.883C28.1044 31.8786 29.2318 32.6601 29.6693 33.8401L31.3933 38.4904L32.9423 43.2018Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M38.3028 63.764C39.5613 63.7643 40.6858 64.55 41.1189 65.7317L42.8256 70.3883L44.3571 75.1054C44.7457 76.3024 44.3459 77.6147 43.356 78.3917L42.7677 78.8535C39.3014 77.9983 35.9311 76.5024 32.8292 74.3351C29.8323 72.2411 27.3376 69.6962 25.3729 66.8561L25.6456 66.0173C26.0348 64.8205 27.1295 63.9938 28.3872 63.9471L33.3433 63.7629L38.3028 63.764Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#1868B7",
    fillRule: "evenodd",
    d: "M61.3876 63.7211C60.1291 63.7214 59.0046 64.5071 58.5715 65.6887L56.8649 70.3453L55.3334 75.0625C54.9447 76.2595 55.3445 77.5718 56.3345 78.3488L56.9228 78.8105C60.3891 77.9553 63.7594 76.4594 66.8612 74.2921C69.8582 72.1981 72.3528 69.6532 74.3176 66.8131L74.0448 65.9743C73.6557 64.7775 72.5609 63.9508 71.3033 63.9041L66.3472 63.7199L61.3876 63.7211Z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20,
    x2: 54.352,
    y1: 20,
    y2: 44.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B70C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2081E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 20,
    x2: 54.352,
    y1: 20,
    y2: 44.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B70C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2081E2",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportsLight);
export default __webpack_public_path__ + "static/media/sports-light.1d631ce5aa9c96fd89a5732a04634462.svg";
export { ForwardRef as ReactComponent };